import React, { Component } from "react";
import { AccountCardComponent } from "../CardComponent/CardComponent";
import { Row, Icon } from "antd";
import history from "../../../../../history/history";
import { selectHeader } from "../../../../../actions/globalActions";
import { connect } from "react-redux";
import _ from "lodash";
import "./pendingAlert.css";
import close from "../../../../../assets/icons/close.svg";
import { getpwUrl, recordError } from "../../../../../utils/commonUtil";
import { isGeminiUser } from "../../../../../utils/sessionUtil";
import InfoAlert from "../../../../../CommonComponents/Info/Alert/Alert";
import { NoticeText } from "../../../../../CommonComponents/Info/Alert/styles";
import { GetNoticeAPI } from "../../../../../services/drupalServices";

export class PendingAlerts extends Component {
  constructor(props) {
    super(props);
    this.navigateViewContribution = this.navigateViewContribution.bind(this);
    this.navigateContributionActivity = this.navigateContributionActivity.bind(
      this
    );
  }

  state = {
    Alert_status: true,
    Maintenance_status: true,
    noticeShowmore: null,
    noticeHeading: null
  };

  closeAlert = () => {
    this.setState({
      Alert_status: false
    });
  };
  closeMaintenanceaAlert = () => {
    this.setState({
      Maintenance_status: false
    });
  };

  navigateViewContribution(data) {
    try {
      this.props.selectHeader("Contribution Activity");
      history.push({
        pathname: "/contributions/activity/view",
        state: {
          transactionId: data.txnId,
          status: data.status,
          giftId: data.giftId
        }
      });
    } catch (error) {
      recordError(error);
    }
  }

  navigateContributionActivity() {
    try {
      this.props.selectHeader("Contribution Activity");
      history.push("/contributions/activity");
    } catch (error) {
      recordError(error);
    }
  }

  EGPPendingPaperWorkAlert = () => {
    return (
      <div>
        <AccountCardComponent
          className={this.state.Maintenance_status === true ? "open" : "close"}
        >
          <div>
            {" "}
            <Icon type="warning" style={{ display: "inline-block" }} />
            <p className=" desktop">
              To complete your{" "}
              <a
                href="#"
                data-test="alert-view"
                onClick={() =>
                  window.open(
                    getpwUrl() +
                      "sites/default/files/2019-05/EndowedGrantForm.pdf",
                    "_blank"
                  )
                }
              >
                Endowed Grant Plan
              </a>
              , please download, complete, and return this form to Vanguard
              Charitable
            </p>
            <p className=" mobile">
              To complete your{" "}
              <a
                href="#"
                data-test="alert-grid"
                onClick={() =>
                  window.open(
                    getpwUrl() +
                      "sites/default/files/2019-05/EndowedGrantForm.pdf",
                    "_blank"
                  )
                }
              >
                Endowed Grant Plan
              </a>
              , please download, complete, and return this form to Vanguard
              Charitable.
            </p>
          </div>
          <img
            src={close}
            style={{ margin: "auto 5px" }}
            onClick={this.closeMaintenanceaAlert}
            className="mr-icon"
            alt="close icon"
          />
        </AccountCardComponent>
      </div>
    );
  };
  AccountSummaryAlert = data => {
    return (
      <div>
        { data ?
        <AccountCardComponent className = "cardNotice">
          <div>
            {" "}
            <p className=" desktop Notice">
              <NoticeText>Notice: </NoticeText>
              <span  dangerouslySetInnerHTML={{ __html: data }} />
            </p>
            <p className=" mobile Notice">
              <NoticeText>Notice: </NoticeText>
              <span dangerouslySetInnerHTML={{ __html: data }} />
            </p>
          </div>
        </AccountCardComponent> : "" }
      </div>
    );
  };

  AccountSummarySelectStdAlert = data => {
    return (
      <div>
        { data ?
        <AccountCardComponent className = "cardNotice">
          <div>
            {" "}
            <p className=" desktop Notice">
              <NoticeText>Notice: </NoticeText>
              <span  dangerouslySetInnerHTML={{ __html: data }} />
            </p>
            <p className=" mobile Notice">
              <NoticeText>Notice: </NoticeText>
              <span dangerouslySetInnerHTML={{ __html: data }} />
            </p>
          </div>
        </AccountCardComponent> : "" }
      </div>
    );
  };

  componentDidMount() {
    GetNoticeAPI.getNoticeContent().then(res => {
      this.setState({
        noticeHeading: res.data[0].field_notice_content,
        noticeShowmore: res.data[0].field_show_more_content
      });
    })
    .catch((err) => console.log(err));
  }
  headingContent = () => (
    <span
      className="headingContent"
      dangerouslySetInnerHTML={{ __html: this.state.noticeHeading }}
    />
  );
  noticeShowmore = () => (
    <span dangerouslySetInnerHTML={{ __html: this.state.noticeShowmore }} />
  );

  displayPagewiseBanner = (pageName) => {
    
    const selectStdContent = "From July 1 to September 30, 2022, Vanguard Charitable will be consolidating investment share classes, which will result in a recordkeeping exchange on your account.<br/><br/>On the date of the exchange, the number of shares and the corresponding NAV for your account's current investment options will change, and your available balance will temporarily appear as $0.00. This recordkeeping exchange will be reflected under Transaction Summary and on your next quarterly statement.<br/><br/>Your account's current investment options or allocations will not change throughout this process. The dollar value of your investments, the investment performance, and the underlying investment expense ratio will not be impacted.<br/><br/>Please contact us at <a href=mailto:donorservice@vanguardcharitable.org>donorservice@vanguardcharitable.org </a> with questions.";

    const exgActivityPageContent1 = "From July 1 to September 30, 2022, Vanguard Charitable will be consolidating investment share classes, which will result in a recordkeeping exchange on your account.<br/><br/>On the date of the exchange, the number of shares and the corresponding NAV for your account's current investment options will change, and your available balance will temporarily appear as $0.00. This recordkeeping exchange will be reflected under Transaction Summary and on your next quarterly statement.<br/><br/>Your account's current investment options or allocations will not change throughout this process. The dollar value of your investments, the investment performance, and the underlying investment expense ratio will not be impacted.<br/><br/>Please contact us at <a href=mailto:donorservice@vanguardcharitable.org>donorservice@vanguardcharitable.org </a> with questions.";

    const exgActivityPageContent2 = "Vanguard Charitable will be consolidating investment share classes, which will result in a recordkeeping exchange on your account.<br/><br/>On the date of the exchange, the number of shares and the corresponding NAV for your account's current investment options will change. This recordkeeping exchange will be reflected under Transaction Summary and on your next quarterly statement.<br/><br/>Your account's current investment options or allocations will not change throughout this process. The dollar value of your investments, the investment performance, and the underlying investment expense ratio will not be impacted.<br/><br/>Please contact us at <a href=mailto:donorservice@vanguardcharitable.org>donorservice@vanguardcharitable.org </a> with questions.";

    switch (pageName) {
      case 'TS':
        return this.props.account_data && this.props.account_data.trim().toLowerCase() === "flag1" ? 
         this.AccountSummarySelectStdAlert(selectStdContent)
        : "";
      case 'EA':
          return this.props.account_data && this.props.account_data.trim().toLowerCase() === "flag1" ? 
           this.AccountSummarySelectStdAlert(exgActivityPageContent1)
          : this.props.account_data && this.props.account_data.trim().toLowerCase() === "flag2" ? this.AccountSummarySelectStdAlert(exgActivityPageContent2): "";
      default:
        return this.props.account_data.accountBannerFlag && this.props.account_data.accountBannerFlag.trim().toLowerCase() === "flag1" ? 
        this.AccountSummarySelectStdAlert(selectStdContent)
        : "";
    }
  };

  render() {
    let pendingContributionDetails = [];   
    const { additional_accnt_dets, account_data } = this.props;
    const { noticeHeading, noticeShowmore } = this.state;
    if (this.props.Loading === false) {
      _.map(this.props.contribution, item => {
        if (item.pendingContribution === true) {
          let chunks = [];
          chunks = item;
          pendingContributionDetails.push(chunks);
        }
      });
    }
    return (
      <div>
      <div className="pending-alert-container">
            <Row>
              { this.displayPagewiseBanner(this.props.pageName) }
            </Row>
          </div>
        { this.props.pageName ? '' : noticeShowmore ? (
          <div className="AccSumInfoAlert">
            <InfoAlert
            type="Notice:  "
            heading={this.headingContent()}
            body={this.noticeShowmore()}
          />
          </div>
        ) : (
          <div className="pending-alert-container">
            <Row>{this.AccountSummaryAlert(noticeHeading)}</Row>
          </div>
        )}
        {pendingContributionDetails.length === 0 ? (
          ""
        ) : (
          <div className="pending-alert-container">
            <Row>
              {pendingContributionDetails.length === 0 ? (
                ""
              ) : pendingContributionDetails.length === 1 ? (
                <div>
                  <AccountCardComponent
                    className={
                      this.state.Alert_status === true ? "open" : "close"
                    }
                  >
                    <div>
                      <Icon
                        type="warning"
                        style={{ display: "inline-block" }}
                      />
                      <p className=" desktop">
                        There is a pending contribution on your account that
                        needs attention.
                        <span
                          data-test="alert-status"
                          onClick={() =>
                            this.navigateViewContribution(
                              pendingContributionDetails[0]
                            )
                          }
                        >
                          <a className="">
                            (Gift ID:{pendingContributionDetails[0].txnId})
                          </a>
                        </span>
                      </p>
                      <p className=" mobile">
                        There is a pending contribution on your account that
                        needs attention.
                        <span
                          data-test="alert-stat"
                          onClick={() =>
                            this.navigateViewContribution(
                              pendingContributionDetails[0]
                            )
                          }
                        >
                          <a className="">
                            (Gift ID:{pendingContributionDetails[0].txnId})
                          </a>
                        </span>
                      </p>
                    </div>
                    <img
                      src={close}
                      style={{ margin: "auto 5px" }}
                      onClick={this.closeAlert}
                      className="mr-icon"
                      alt="close icon"
                    />
                  </AccountCardComponent>
                </div>
              ) : (
                <div>
                  <AccountCardComponent
                    className={
                      this.state.Alert_status === true ? "open" : "close"
                    }
                  >
                    <div>
                      <Icon
                        type="warning"
                        style={{ display: "inline-block" }}
                      />

                      <p className=" desktop">
                        There are
                        <a
                          href="#"
                          data-test="account-status"
                          onClick={() => this.navigateContributionActivity()}
                        >
                          {" "}
                          pending contributions
                          {/* <span>
                            <span class="tooltiptext">Coming Soon...</span>
                          </span> */}{" "}
                        </a>
                        on your account that needs attention.
                      </p>
                      <p className=" mobile">
                        There are
                        <a
                          href="#"
                          data-test="account-stat"
                          onClick={() => this.navigateContributionActivity()}
                        >
                          {" "}
                          pending contributions
                          {/* <span>
                            <span class="tooltiptext">Coming Soon...</span>
                          </span> */}
                        </a>{" "}
                        on your account that needs attention.
                      </p>
                    </div>
                    <img
                      src={close}
                      style={{ margin: "auto 5px" }}
                      onClick={this.closeAlert}
                      className="mr-icon"
                      alt="close icon"
                    />
                  </AccountCardComponent>
                </div>
              )}
            </Row>
          </div>
        )}
        <div className="pending-alert-container">
          <Row>
            {this.props.account_data.lowBalanceIndicator === "N" ||
            !this.props.account_data.lowBalanceIndicator ? (
              ""
            ) : (
              <div>
                <AccountCardComponent
                  className={
                    this.state.Maintenance_status === true ? "open" : "close"
                  }
                >
                  <div>
                    {" "}
                    <Icon type="warning" style={{ display: "inline-block" }} />
                    <p className=" desktop">
                      As described in our{" "}
                      <a
                        href="#"
                        data-test="pending-status"
                        onClick={() => {
                          try {
                            window.open(
                              getpwUrl() +
                                "/company-policies/policies-and-guidelines"
                            );
                          } catch (error) {
                            recordError(error);
                          }
                        }}
                      >
                        Policies {"&"} Guidelines
                      </a>
                      , a $250 annual maintenance fee will be assessed and charged in early February. Your account will be subject to this fee if your account has been open for more than 6 months and your balance is below $25,000 at that time.
                    </p>
                    <p className=" mobile">
                      As described in our{" "}
                      <a
                        href="#"
                        data-test="pending-stat"
                        onClick={() => {
                          try {
                            window.open(
                              getpwUrl() +
                                "/company-policies/policies-and-guidelines"
                            );
                          } catch (error) {
                            recordError(error);
                          }
                        }}
                      >
                        Policies {"&"} Guidelines
                      </a>
                      , a $250 annual maintenance fee will be assessed and charged in early February. Your account will be subject to this fee if your account has been open for more than 6 months and your balance is below $25,000 at that time.
                    </p>
                  </div>
                  <img
                    src={close}
                    style={{ margin: "auto 5px" }}
                    onClick={this.closeMaintenanceaAlert}
                    className="mr-icon"
                    alt="close icon"
                  />
                </AccountCardComponent>
              </div>
            )}
          </Row>
        </div>
        <div className="pending-alert-container">
          <Row>
            {
            (isGeminiUser() || additional_accnt_dets === "Account Advisor" ) && account_data.egppaperWorkPending ? 
               this.EGPPendingPaperWorkAlert()
            : ""
            }
          </Row>
        </div>
      </div>
    );
  }
}

export const mapDispatchToProps = dispatch => {
  return {
    selectHeader: data => dispatch(selectHeader(data))
  };
};

export default connect(
  null,
  mapDispatchToProps
)(PendingAlerts);
